import { JSX } from 'preact'
import { forwardRef } from 'preact/compat'
import classnames from 'classnames'
import { WidgetInstance } from '../types'
import { previewProps } from '../preview'
import { useAppDispatch } from '../store/store'
import { setView, closeWidgetView } from '../store/widgets'
import { BlockTree } from './Blocks/BlockTree'
import { useComponentStyle } from './Style'
import { SystemButton } from './SystemButton'

interface Props {
  className?: string
  widget: WidgetInstance
}

export const Teaser = forwardRef<HTMLDivElement, Props>(function Teaser(
  { className, widget },
  ref,
): JSX.Element | null {
  const { teaser } = widget

  const dispatch = useAppDispatch()
  const { classes } = useComponentStyle('teaser', teaser || {})

  if (!teaser) {
    return null
  }

  const handleClick = () => {
    dispatch(setView(widget.id, 'main'))
  }

  const handleClose = (e: Event) => {
    e.stopPropagation()
    dispatch(closeWidgetView(widget.id, 'teaser'))
  }

  const { closeButton, children } = teaser

  return (
    <div
      ref={ref}
      className={classnames(className, classes, 'clickable')}
      onClick={handleClick}
      {...previewProps('teaser')}
    >
      {children?.map(c => (
        <BlockTree root={c} />
      ))}
      {closeButton?.visible && <SystemButton name="close" {...closeButton} onClick={handleClose} />}
    </div>
  )
})
